// Servizio Assistente AI: config pubblica, invio messaggi e config admin.
import { api, unwrap } from './client';

export const assistantService = {
  // pubblico
  publicConfig: () => unwrap(api.get('/assistant/config')),
  chat: (body) => unwrap(api.post('/assistant/chat', body)),
  feedback: (body) => unwrap(api.post('/assistant/feedback', body)),
  // admin
  getConfig: () => unwrap(api.get('/assistant/admin/config')),
  updateConfig: (body) => unwrap(api.put('/assistant/admin/config', body)),
  models: () => unwrap(api.get('/assistant/admin/models')),
  conversations: (params) => unwrap(api.get('/assistant/admin/conversations', { params })),
};
